import {URLS} from "./app-urls";
import {AbstractService, Filters} from "./abstract-service";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";
import {ImportRelatedCost} from "../models/basic/import-related-cost";

export type ImportRelatedCostsFilter = Filters & {
    years?: string,
    client?: string,
};

export class ImportRelatedCostService extends AbstractService<ImportRelatedCost> {

    constructor() {
        super(URLS.IMPORT_RELATED_COST);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if(processedFilter.years) {
            if(!processedFilter.years) {
                delete processedFilter.years;
            }
        }

        return processedFilter;
    }

    async listYears(): Promise<AxiosResponse<{ years: number[] }>> {
        const path = `${this.path}list_years/`;
        return await trackPromise(Api.get(path));
    }
}
